import {CityProps, translatedCityProps} from 'modules/cities/types';
import {CouponProps, translatedCouponProps} from 'modules/coupons/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum NotificationTypeEnum {
  oneTime = 'oneTime',
  periodical = 'periodical',
}

export interface NotificationProps {
  id: string;
  active: boolean;
  couponId: string;
  coupon: CouponProps;
  cityId: string;
  city: CityProps;
  title: string;
  body: string;
  type: NotificationTypeEnum;
  day: string;
  date: string;
  time: string;
  deliveredAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export const translatedNotificationProps: TranslatedKeys<NotificationProps> = {
  active: 'Ativo?',
  couponId: 'Cupom',
  coupon: {...translatedCouponProps, name: 'Cupom'},
  cityId: 'Cidade',
  city: {...translatedCityProps, name: 'Cidade'},
  title: 'Título',
  body: 'Mensagem',
  type: 'Tipo',
  day: 'Dia',
  date: 'Data',
  time: 'Horário',
  deliveredAt: 'Entregue em',
  createdAt: 'Criado em',
  updatedAt: 'Atualizado em',
};
